import angular from 'angular'
import './print_history.service'

angular.module('admin.print', ['admin.print.service']).controller('PrintAdminCtrl', PrintAdminCtrl)

/** @ngInject */
function PrintAdminCtrl($stateParams, PrintService) {
  var vm = this
  vm.items = []
  vm.collectibleId = null
  vm.edition = null
  vm.printNumber = null
  vm.collectibleId = $stateParams.collectibleId
  vm.edition = $stateParams.edition
  vm.printNumber = $stateParams.printNumber

  vm.load = function() {
    if (vm.collectibleId === null || vm.collectibleId === undefined || vm.collectibleId === '') {
      swal('Please enter a Collectible ID', '', 'warning')
      return
    }

    if (vm.edition === null || vm.edition === undefined || vm.edition === '') {
      swal('Please enter the Edition', '', 'warning')
      return
    }

    if (vm.printNumber === null || vm.printNumber === undefined || vm.printNumber === '') {
      swal('Please enter the Print Number', '', 'warning')
      return
    }

    vm.items = []

    PrintService.list(vm.collectibleId, vm.edition, vm.printNumber).then(function(result) {
      for (var i = 0; i < result.results.length; i++) {
        switch (result.results[i].k) {
          case 1:
            result.results[i].kname = 'Bundle Purchase'
            break
          case 2:
            result.results[i].kname = 'Trade'
            break
          case 3:
            result.results[i].kname = 'Listing'
            break
          case 4:
            result.results[i].kname = 'eBay'
            break
          case 5:
            result.results[i].kname = 'Account Transfer'
            break
          case 6:
            result.results[i].kname = 'Print Transfer'
            break
          default:
            result.results[i].kname = 'Unknown'
            break
        }

        switch (result.results[i].curr) {
          case 1:
            result.results[i].currname = 'Coins'
            break
          case 2:
            result.results[i].currname = 'USD'
            break
          default:
            result.results[i].currname = 'Unknown'
            break
        }

        result.results[i].ts = new Date(
          parseInt(
            result.results[i].ts
              .toString()
              .substring(0, result.results[i].ts.toString().length - 3),
          ),
        )
        result.results[i].durstr = moment.duration(result.results[i].dur / 1000000).humanize()
      }
      vm.items = result.results
    })
  }

  if ($stateParams.collectibleId > 0) {
    vm.load()
  }
}
